import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum EResetRealtorRatingListActionType {
  Reset = 'realtorRatingList/resetRealtorRatingList',
}

export type TResetRealtorRatingList = ITypedReduxAction<EResetRealtorRatingListActionType.Reset>;
